import { all, call, takeLatest, getContext } from 'redux-saga/effects';

import { Logger } from '../../utils/Logger';

import { REQUEST_FEATURES_AVAILABILITY } from './types';
const logger = new Logger('Saga:Membership');

export function* requestMembershipFeaturesAvailableSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    yield call(
      authApiService.get,
      routerService.generate('api.membership.features_availability', { features: action.features }),
    );

    action.promise && action.promise.resolve(true);
  } catch (error) {
    logger.info('Membership feature not available with error', error);
    action.promise && action.promise.reject(false);
  }
}

export default function* membershipSaga() {
  return yield all([
    takeLatest(REQUEST_FEATURES_AVAILABILITY, requestMembershipFeaturesAvailableSaga),
  ]);
}
